import PageFactory from '../PageFactory';
import UnauthorizedIllustration from './UnauthorizedIllustration';

const Unauthroized = (): React.ReactNode =>
  PageFactory(UnauthorizedIllustration, 'Access Required', [
    "You don't have permission to access this resource or it doesn't exist.",
  ]);

export default Unauthroized;
